import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { ButtonContained } from '@/UI/Buttons/AppButton';
import { PlusIcon } from '@/UI/Icons/PlusIcon';
import { I18N_KEYS } from '@/language/keys';

interface AddVariableButtonProps {
  onClick?: () => void;
  type?: 'button' | 'text';
  text?: string;
}

export const AddVariableButton = ({ onClick, type = 'button', text }: AddVariableButtonProps) => {
  const { t } = useTranslation();

  const buttonText = text ?? t(I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V3.ADD_VARIABLE);

  if (type === 'text') {
    return (
      <Typography variant="body-sm-rg" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <PlusIcon height={16} width={16} />
        {buttonText}
      </Typography>
    );
  }

  return (
    <ButtonContained mode="text" size="small" startIcon={<PlusIcon height={16} width={16} />} onClick={onClick}>
      {buttonText}
    </ButtonContained>
  );
};
